import {Box, Skeleton, Typography} from '@mui/material';

const ExpandedRow = ({row, generating}: any) => {
  return (
    <Box bgcolor="#182231">
      {!generating ? (
        <Typography
          sx={{p: 2}}
          className="typo-text body3_size"
          color="white"
          maxWidth={687}
          marginLeft={7}
          data-testid={`expanded-row-summary-${row.docId}`}
        >
          {row.summary}
        </Typography>
      ) : null}
    </Box>
  );
};

export default ExpandedRow;
